import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import { getQuoteServicesList } from '../helpers'

const EstimatedTotalDisclaimer = ({
  services
}) =>
  <Block>
    <Disclaimer>*Estimated Total does not include&nbsp;
      <ServicesList>{ getQuoteServicesList(services) }.</ServicesList>
    </Disclaimer>
  </Block>

EstimatedTotalDisclaimer.propTypes = {
  services: PropTypes.arrayOf(PropTypes.shape())
}

export default EstimatedTotalDisclaimer

const Block = styled.div`
  display: flex;
`

const Disclaimer = styled.p`
  ${Mixin.font.GothamMediumItalic(14, 500, 18)}
  display: block;
  width: 65%;
  margin: 0;
  font-style: italic;
`

const ServicesList = styled.span`
  ${Mixin.font.GothamBold(14)}
`
